import loadable from '@loadable/component';
import { LoadableFallback } from '../../../../../packages/LoadableHelpers';

export const AllFiltersContentContainerLoadable = loadable(() => import('./AllFiltersContentContainer'), {
  resolveComponent: ({ AllFiltersContentContainer }) => AllFiltersContentContainer,
  fallback: <LoadableFallback spinnerSize={42} />,
  ssr: false,
});
